export const WalletIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1269_18603)">
        <path
          d="M3 5.6V18.4C3 18.8243 3.16857 19.2313 3.46863 19.5314C3.76869 19.8314 4.17565 20 4.6 20H20.6C20.8122 20 21.0157 19.9157 21.1657 19.7657C21.3157 19.6157 21.4 19.4122 21.4 19.2V8C21.4 7.78783 21.3157 7.58434 21.1657 7.43431C21.0157 7.28429 20.8122 7.2 20.6 7.2H4.6C4.17565 7.2 3.76869 7.03143 3.46863 6.73137C3.16857 6.43131 3 6.02435 3 5.6ZM3 5.6C3 5.17565 3.16857 4.76869 3.46863 4.46863C3.76869 4.16857 4.17565 4 4.6 4H18.2"
          stroke="black"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 14.1992C17.5523 14.1992 18 13.7515 18 13.1992C18 12.6469 17.5523 12.1992 17 12.1992C16.4477 12.1992 16 12.6469 16 13.1992C16 13.7515 16.4477 14.1992 17 14.1992Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1269_18603">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
